import { useEffect, useRef } from "react";
import { gsap } from "gsap";

import afrotech from "../../assets/LandingPage/Sponsors/sponsor4.png";
import philadelphia from "../../assets/LandingPage/Sponsors/sponsor1.png";
import diversity from "../../assets/LandingPage/Sponsors/sponsor2.png";
import microsoft from "../../assets/LandingPage/Sponsors/sponsor3.png";
import amazon from "../../assets/LandingPage/Sponsors/Amazon Logo.png";
import aon from "../../assets/LandingPage/Sponsors/Aon logo.png";
import atlassian from "../../assets/LandingPage/Sponsors/atlassian-logo-atlassian-logo.png";
import boeing1 from "../../assets/LandingPage/Sponsors/boeing-logo.png";
import cdw from "../../assets/LandingPage/Sponsors/cdw-logo-cdw-corporation-logo.png";
import cisco from "../../assets/LandingPage/Sponsors/cisco-logo.png";
import comcast from "../../assets/LandingPage/Sponsors/comcast nbc universal.jpg";
import gartner from "../../assets/LandingPage/Sponsors/Gartner Logo.png";
import georgeMason from "../../assets/LandingPage/Sponsors/George-Mason-University-New.png";
import humana from "../../assets/LandingPage/Sponsors/humana-logo.png";
import jpmorgan from "../../assets/LandingPage/Sponsors/jp-morgan-logo.png";
import nglcc from "../../assets/LandingPage/Sponsors/NGLCC logo.png";
import nike from "../../assets/LandingPage/Sponsors/Nike-Logo.png";
import nmsdc from "../../assets/LandingPage/Sponsors/NMSDC.png";
import stanford from "../../assets/LandingPage/Sponsors/Stanford.png";
import target from "../../assets/LandingPage/Sponsors/Target-Logo.png";
import ucla from "../../assets/LandingPage/Sponsors/UCLA-Symbol.png";
import unitedHealthcare from "../../assets/LandingPage/Sponsors/United healthcare logo.png";
import weconnect from "../../assets/LandingPage/Sponsors/weconnect logo.png";
import washingtonGas from "../../assets/LandingPage/Sponsors/Wshington Gas logo.png";

export default function SupportedBy() {
  const rowTopRef = useRef(null);
  const rowBottomRef = useRef(null);

  const logos = [
    afrotech,
    philadelphia,
    microsoft,
    diversity,
    aon,
    atlassian,
    boeing1,
    cdw,
    amazon,
    cisco,
    comcast,
    gartner,
    georgeMason,
    humana,
    jpmorgan,
    nglcc,
    nike,
    nmsdc,
    stanford,
    target,
    ucla,
    unitedHealthcare,
    weconnect,
    washingtonGas,
  ];

  useEffect(() => {
    const rowTop = rowTopRef.current;
    const rowBottom = rowBottomRef.current;
    if (!rowTop || !rowBottom) return;

    const isMobile = window.innerWidth < 640;
    const duration = isMobile ? 140 : 100;

    const totalWidthTop = rowTop.scrollWidth / 2;
    const totalWidthBottom = rowBottom.scrollWidth / 2;

    gsap.to(rowTop, {
      x: -totalWidthTop,
      duration,
      repeat: -1,
      ease: "linear",
    });

    gsap.fromTo(
      rowBottom,
      { x: -totalWidthBottom },
      {
        x: 0,
        duration,
        repeat: -1,
        ease: "linear",
      }
    );
  }, []);

  const sizeOverrides = {
    amazon: "scale-110 sm:scale-125",
    nglcc: "scale-125 sm:scale-150",
    cdw: "scale-125 sm:scale-150",
    atlassian: "scale-110 sm:scale-125",
    jpmorgan: "scale-90",
    diversity: "scale-75",
    unitedhealthcare: "scale-125 sm:scale-150",
  };

  const renderRow = (rowRef, logosArr = logos) => (
    <div
      ref={rowRef}
      className="
        flex
        items-center
        gap-6 sm:gap-10 lg:gap-16
        whitespace-nowrap
      "
    >
      {[...logosArr, ...logosArr].map((logo, index) => {
        const overrideKey = Object.keys(sizeOverrides).find((key) =>
          logo.toLowerCase().includes(key)
        );
        const overrideClass = overrideKey ? sizeOverrides[overrideKey] : "";

        return (
          <div
            key={index}
            className="
              flex
              items-center
              justify-center
              h-10 sm:h-14 lg:h-16
            "
          >
            <div
              className={`
                flex
                items-center
                justify-center
                h-full
                w-[90px] sm:w-[120px] lg:w-[140px]
                overflow-hidden
                ${overrideClass}
              `}
            >
              <img
                src={logo}
                alt="Company logo"
                className="
                  object-contain
                  max-h-full
                  max-w-full
                  grayscale
                "
              />
            </div>
          </div>
        );
      })}
    </div>
  );

  return (
    <section
      className="
      w-full
      bg-white
      overflow-hidden
      py-12 sm:py-16 lg:py-20
    "
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <p
          className="
          text-center
          text-gray-600
          text-sm sm:text-base
          mb-8 sm:mb-12
        "
        >
          Companies We’ve Engaged With
        </p>

        {renderRow(rowTopRef)}

        <div className="mt-6 sm:mt-10">
          {renderRow(rowBottomRef, [...logos].reverse())}
        </div>
      </div>
    </section>
  );
}
